module.exports = __webpack_public_path__ + "img/wechat.8fafeb93.png";